module.exports = __webpack_public_path__ + "2ca858644a8ba3396f3b3a2a7918bad7.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/fonts/bulorounded-blackitalic.ttf
 ** module id = 23
 ** module chunks = 0
 **/